// extracted by mini-css-extract-plugin
export default {"root":"accordion_root__TP7pq","item":"accordion_item__jUxBc","header":"accordion_header__fFq-b","trigger":"accordion_trigger__f9jY5","content":"accordion_content__ioVpf"};